import type { LimitesHomogeneizacao } from './types';

export const calcularLimitesHomogeneizacao = (
  dadosValorTerreno: Array<{ valorUnitarioFinal: number }>
): LimitesHomogeneizacao => {
  const valoresValidos = dadosValorTerreno
    .map(item => item.valorUnitarioFinal)
    .filter(valor => valor > 0);

  const n = valoresValidos.length;
  if (n === 0) {
    return { numeroElementos: 0, unitarioHomog: 0, limiteSuperior: 0, limiteInferior: 0 };
  }

  const media = valoresValidos.reduce((acc, val) => acc + val, 0) / n;

  return {
    numeroElementos: n,
    unitarioHomog: media,
    limiteSuperior: media * 1.3,
    limiteInferior: media * 0.7,
  };
};

/**
 * Verifica se o valor está dentro do intervalo de ±30% (limites NBR 14653)
 * Usado apenas para VISUALIZAÇÃO (marcar em vermelho), NÃO para filtrar dados
 * Todas as amostras são incluídas nos cálculos independente deste resultado
 */
export const valorDentroDoIntervalo = (
  valor: number,
  limiteInferior: number,
  limiteSuperior: number
): boolean => {
  if (valor === 0) return true;
  return valor >= limiteInferior && valor <= limiteSuperior;
};

export const filtrarValoresValidos = (
  dados: Array<{ valorUnitarioFinal: number }>
): number[] => {
  return dados
    .map(item => item.valorUnitarioFinal)
    .filter(valor => valor > 0);
};
